import React, { useState, useEffect, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Hidden, Button, TextField, Checkbox, Icon } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import PortableText from "../portableText";
import GatedContentEmailSignupWidget from "../widgets/gatedContentEmailSignupWidget/gatedContentEmailSignupWidget";
import Tint from "./img/tint.svg";
import * as styles from "./originalFaded.module.css";

const useStyles = makeStyles((theme) => ({
  fadedContainer: {
    pointerEvents: "none",
    backgroundImage: 'url(./img/tint.svg)'
  }
}));

const OriginalNoFade = ({
  handleEmailCaptured,
  emailSignupWidgetTitle,
  emailSignupWidgetImage,
  emailSignupWidgetParagraphText,
  emailSignupWidgetButtonText,
  emailSignupWidgetTextboxPlaceholder,
  _rawGatedContentBody,
  _rawGatedContentReadMoreText,
  brazeCustomAttributes,
  subscribedCallback,
}) => {
  const classes = useStyles();

  useEffect(() => {

  }, []);

  return (
    <>
      <div className={styles.fadedContainer}>
        <PortableText blocks={_rawGatedContentBody} />
        <div className={styles.tint}></div>
      </div>

      <PortableText blocks={_rawGatedContentReadMoreText} />

      <GatedContentEmailSignupWidget
        title={emailSignupWidgetTitle}
        image={emailSignupWidgetImage}
        paragraphText={emailSignupWidgetParagraphText}
        buttonText={emailSignupWidgetButtonText}
        textboxPlaceholder={emailSignupWidgetTextboxPlaceholder}
        subscribedCallback={subscribedCallback}
        brazeCustomAttributes={brazeCustomAttributes}
      />
    </>
  );
};

export default OriginalNoFade;
